import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "project-item__info" }
const _hoisted_2 = { class: "project-item__text" }
const _hoisted_3 = { class: "project-item__title-row" }
const _hoisted_4 = {
  key: 0,
  class: "project-item__caret"
}
const _hoisted_5 = { class: "project-item__title" }
const _hoisted_6 = { class: "project-item__budget-content" }
const _hoisted_7 = { class: "project-item__budget-header" }
const _hoisted_8 = { class: "project-item__budget-type" }
const _hoisted_9 = { class: "project-item__budget-value" }
const _hoisted_10 = {
  key: 0,
  class: "project-item__budget-content"
}
const _hoisted_11 = { class: "project-item__budget-header" }
const _hoisted_12 = { class: "project-item__budget-value" }
const _hoisted_13 = {
  key: 1,
  class: "project-item__budget-empty"
}

import { computed } from "vue";
import ProgressBar from "./ProgressBar.vue";
import { WorkingPeriod } from "@/helpers/project/typesDefinition";
import IconButton from "./IconButton.vue";
import { formatPrice } from "@/helpers/utils";

interface ProjectItemProps {
  id: string;
  color?: string | null;
  title: string;
  percentage?: number | number[];
  dangerPercent?: number;
  max?: string;
  value?: string;
  isValueError?: boolean;
  period: WorkingPeriod;
  userId: string;
  isFavorite?: boolean;
  // Budget tracking type (global or monthly)
  budgetTracking?: string;
  // Personal budget props
  personalAllocatedAmount?: number;
  personalTimesheetAmount?: number;
  teamPercentage?: number;
  showTeamBudget?: boolean;
  showPersonalBudget?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectItem',
  props: {
    id: {},
    color: {},
    title: {},
    percentage: {},
    dangerPercent: {},
    max: {},
    value: {},
    isValueError: { type: Boolean },
    period: {},
    userId: {},
    isFavorite: { type: Boolean },
    budgetTracking: {},
    personalAllocatedAmount: {},
    personalTimesheetAmount: {},
    teamPercentage: {},
    showTeamBudget: { type: Boolean, default: true },
    showPersonalBudget: { type: Boolean, default: true }
  },
  emits: ["toggleFavorite"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v0a6f7110": (_ctx.color)
}))

const props = __props;
const emit = __emit;

// Compute team percentage (from global budget)
const teamPercentage = computed(() => {
  if (props.teamPercentage !== undefined) {
    return Math.min(100, Math.round(props.teamPercentage * 100));
  }
  // Fallback to percentage prop or 0
  if (typeof props.percentage === "number") {
    return Math.min(100, Math.round(props.percentage * 100));
  }
  return 0;
});

// Compute personal percentage
const personalPercentage = computed(() => {
  if (props.personalAllocatedAmount && props.personalAllocatedAmount > 0) {
    const percent =
      (props.personalTimesheetAmount ?? 0) / props.personalAllocatedAmount;
    return Math.min(100, Math.round(percent * 100));
  }
  return null;
});

const toggleFavorite = (e: Event) => {
  e.stopPropagation();
  emit("toggleFavorite", !props.isFavorite);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["project-item", {
      'project-item--team-only': __props.showTeamBudget && !__props.showPersonalBudget,
      'project-item--personal-only': !__props.showTeamBudget && __props.showPersonalBudget,
      'project-item--both': __props.showTeamBudget && __props.showPersonalBudget,
    }]),
    tabindex: "0",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event))),
    onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('click', $event.target)), ["enter","space"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(IconButton, {
        "icon-name": __props.isFavorite ? 'mdi:star' : 'mdi:star-outline',
        color: __props.isFavorite ? 'primary' : undefined,
        onClick: toggleFavorite
      }, null, 8, ["icon-name", "color"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.color)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.title), 1)
        ])
      ])
    ]),
    (__props.showTeamBudget)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["project-item__budget-column", { 'project-item__budget-column--span': !__props.showPersonalBudget }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(ProgressBar, {
              class: "project-item__progress",
              percentages: [teamPercentage.value / 100],
              "danger-percent": __props.dangerPercent,
              color: __props.color
            }, null, 8, ["percentages", "danger-percent", "color"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(__props.budgetTracking), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(__props.value) + " / " + _toDisplayString(__props.max), 1)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (__props.showPersonalBudget)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["project-item__budget-column", { 'project-item__budget-column--span': !__props.showTeamBudget }])
        }, [
          (__props.personalAllocatedAmount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(ProgressBar, {
                  class: "project-item__progress",
                  percentages: [personalPercentage.value / 100],
                  "danger-percent": __props.dangerPercent,
                  color: "var(--color-success, #4caf50)"
                }, null, 8, ["percentages", "danger-percent"]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "project-item__budget-type" }, null, -1)),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(formatPrice)(__props.personalTimesheetAmount ?? 0)) + " / " + _toDisplayString(_unref(formatPrice)(__props.personalAllocatedAmount)), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
        ], 2))
      : _createCommentVNode("", true)
  ], 34))
}
}

})